import React from 'react';
const noMore = ['No more starting every new lesson from a blank page.', 'No more searching through disconnected technical resources.', 'No more struggling to find clear machinery diagrams.', 'No more relying entirely on text-heavy explanations.', 'No more assembling equipment comparisons independently.', 'No more preparing every workplace scenario from zero.', 'No more searching for separate resources for every type of machine.', 'No more creating every classroom knowledge check independently.', 'No more wasting valuable preparation time gathering teaching material.'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-yellow-50 relative overflow-hidden" data-id="element-117" data-mp="vu8ap3k9cd0j">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-118" data-mp="qwq43jtpq9vp">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-8 leading-tight text-neutral-900 uppercase" data-id="element-119" data-mp="14v6izy1qb6ox">
          Next Month You Can Still Be Searching for Heavy Equipment Training Materials...
          <br data-id="element-120" data-mp="2c56cy8srgdli" />
          <span className="text-amber-600" data-id="element-121" data-mp="2c5pxzydpji3r">
            Or You Can Have a Complete Visual Training System Ready for Your Next Class.
          </span>
        </h2>
        <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white p-8 rounded-2xl border border-neutral-200" data-id="element-122" data-mp="2m2ubl9thm58y">
          {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-123" data-mp="2r3ibym3lvyfu">
              <span className="text-amber-600 mt-0.5" aria-hidden="true" data-id="element-124" data-mp="2v4257el26hwp">
                ▸
              </span>
              <span className="text-neutral-800" data-id="element-125" data-mp="301k7im4klyvq">{item}</span>
            </div>)}
        </div>
        <p className="text-xl md:text-2xl font-bold text-neutral-900 mb-2" data-id="element-126" data-mp="34udezhrfblbi">
          Heavy Equipment Instructor Atlas Doesn&apos;t Replace Your Professional Experience.
        </p>
        <p className="text-xl text-neutral-800/80 mb-6" data-id="element-127" data-mp="3esayjryc8txs">
          It supports your teaching with a structured visual reference system designed to provide
          more:
        </p>
        <p className="text-lg md:text-2xl font-extrabold tracking-widest text-amber-600" data-id="element-128" data-mp="1jo3hri2jm741">
          CLARITY · STRUCTURE · CONSISTENCY · CONFIDENCE
        </p>
      </div>
    </section>;
}